import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/hero-image.png'


const _withScopeId = n => (_pushScopeId("data-v-65d88e3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case" }, null, -1))
const _hoisted_4 = { class: "grid gray white flx max mm20" }
const _hoisted_5 = { class: "rows mt10" }
const _hoisted_6 = {
  class: "roxe-heading-1",
  id: "font-size"
}
const _hoisted_7 = {
  class: "roxe-heading mt20",
  id: "font-size"
}
const _hoisted_8 = { class: "frl mt20" }
const _hoisted_9 = {
  href: "/contact",
  class: "scroll-view"
}
const _hoisted_10 = {
  id: "buttons",
  class: "rows center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "roxe-restaurant-bgcolor" }
const _hoisted_14 = { class: "wedo max" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "roxe-restaurant black-color",
  id: "font-size"
}, "WHY ROXE ONE FOR RESTAURANTS?", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h3-1 roxe-one mtb30",
  id: "font-size"
}, " Roxe One provides an innovative internet and cloud-based solution for 360° restaurant management. It consolidates the dine-in, online, and delivery platforms. It automates inventory and supply management with vendors. And the payments are processed securely at competitive fees. ", -1))
const _hoisted_17 = { class: "row mtb30" }
const _hoisted_18 = { class: "column" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roxe-icon-text" }, "One-stop platform for restaurant management", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "roxe-icon-text-1" }, "One-stop platform for restaurant management", -1))
const _hoisted_21 = { class: "column" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roxe-icon-text" }, [
  /*#__PURE__*/_createTextVNode("Internet Cloud-based "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("POS system")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "roxe-icon-text-1" }, [
  /*#__PURE__*/_createTextVNode("Internet Cloud-based "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("POS system")
], -1))
const _hoisted_24 = { class: "column" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roxe-icon-text" }, [
  /*#__PURE__*/_createTextVNode("Save money by cutting your"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("operating costs")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "roxe-icon-text-1" }, [
  /*#__PURE__*/_createTextVNode("Save money by cutting your"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("operating costs")
], -1))
const _hoisted_27 = { class: "column" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roxe-icon-text" }, "Trusted by 2700+ restaurants", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "roxe-icon-text-1" }, "Trusted by 2700+ restaurants", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "roxe-one-2",
  id: "font-size"
}, " There is no cost or fees for signing up, so reach out to our sales associate today! ", -1))
const _hoisted_31 = {
  href: "/contact",
  class: "scroll-view"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "roxe-management-service",
  id: "font-size"
}, "Restaurant Management Services", -1))
const _hoisted_33 = { class: "flex block max mtb30" }
const _hoisted_34 = { class: "fl1" }
const _hoisted_35 = { class: "fl-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, "Digital Menus"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ft18 restaurant-service",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Ditch printed menus and update your menu pictures, items and pricing in real time with one click ")
], -1))
const _hoisted_37 = { class: "fl-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, "Kitchen Order System"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ft18 restaurant-service",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Kitchen receives tickets instantly, and dishes are delivered to the tables orderly ")
], -1))
const _hoisted_39 = { class: "fl-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Delivery Platform Integration "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ft18 restaurant-service",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Manage all your delivery platforms from one place, and automatically consolidate and process orders ")
], -1))
const _hoisted_41 = { class: "fl1" }
const _hoisted_42 = { class: "fl-item" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, "Contactless Ordering"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ft18 restaurant-service",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Dine-in customers can order by phone or tablet, and provide higher table turnover rate ")
], -1))
const _hoisted_44 = { class: "fl-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, "Contactless Checkout"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ft18 restaurant-service",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Accept all contactless payments, and elevate customer experience and staff efficiency ")
], -1))
const _hoisted_46 = { class: "fl-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, "Reception Management"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ft18 restaurant-service",
    style: {"letter-spacing":"-0.5px"},
    id: "font-size"
  }, " Better customer waitlist, time tracking and reservation management ")
], -1))
const _hoisted_48 = {
  href: "/contact",
  class: "scroll-view"
}
const _hoisted_49 = { style: {"background-color":"rgba(121, 217, 173, 0.2)"} }
const _hoisted_50 = { class: "wedo-1 max" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "backend-management-header",
  id: "font-size"
}, "Backend Management", -1))
const _hoisted_52 = { class: "row mtb30" }
const _hoisted_53 = { class: "column" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "backend-mangement-text" }, "Inventory Management", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "backend-mangement-text-1" }, " Automated inventory and vendor supply management in real time ", -1))
const _hoisted_56 = { class: "column" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "backend-mangement-text" }, "Business Data Reporting", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "backend-mangement-text-1" }, " Check your cost analysis, data insights and reporting to understand your business better ", -1))
const _hoisted_59 = { class: "column" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "backend-mangement-text" }, "CRM Management", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "backend-mangement-text-1" }, " Tools to manage your customers, launch targeted marketing, discounts, gift cards and more ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "roxe-one-2",
  id: "font-size"
}, " Partner With Us! Contact us and let's set up your business together! ", -1))
const _hoisted_63 = {
  href: "/contact",
  class: "scroll-view"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "div",
  id: "partnerWithUs"
}, null, -1))
const _hoisted_65 = {
  method: "POST",
  action: "https://apifiny.activehosted.com/proc.php",
  id: "_form_17_",
  class: "_form _form_17 _inline-form _dark",
  novalidate: ""
}
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"u\" value=\"16\" data-v-65d88e3f><input type=\"hidden\" name=\"f\" value=\"16\" data-v-65d88e3f><input type=\"hidden\" name=\"s\" data-v-65d88e3f><input type=\"hidden\" name=\"c\" value=\"0\" data-v-65d88e3f><input type=\"hidden\" name=\"m\" value=\"0\" data-v-65d88e3f><input type=\"hidden\" name=\"act\" value=\"sub\" data-v-65d88e3f><input type=\"hidden\" name=\"v\" value=\"2\" data-v-65d88e3f><input type=\"hidden\" name=\"or\" value=\"21eed4176730b566b611471600851094\" data-v-65d88e3f>", 8)
const _hoisted_74 = { class: "_form-content" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_form_element _x71727573 _full_width _clear" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_form-title" }, "Subscribe for Email Updates")
], -1))
const _hoisted_76 = { class: "_form_element _x80337498 _full_width" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "yourname",
  class: "_form-label"
}, " Your Name* ", -1))
const _hoisted_78 = { class: "_field-wrapper" }
const _hoisted_79 = ["error", "errMsg", "value"]
const _hoisted_80 = { class: "_form_element _x11924557 _full_width" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "_form-label"
}, " Email Address* ", -1))
const _hoisted_82 = { class: "_field-wrapper" }
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "_form_element _x35719816 _full_width" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "restaurantname",
  class: "_form-label"
}, " Restaurant Name* ", -1))
const _hoisted_86 = { class: "_field-wrapper" }
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "_form_element _field46 _full_width" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "website",
  class: "_form-label"
}, " Website* ", -1))
const _hoisted_90 = { class: "_field-wrapper" }
const _hoisted_91 = ["value"]
const _hoisted_92 = { class: "_form_element _field26 _full_width" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "_form-label"
}, " Message ", -1))
const _hoisted_94 = { class: "_field-wrapper" }
const _hoisted_95 = ["value"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_button-wrapper _full_width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "_form_17_submit",
    class: "_submit",
    type: "submit"
  }, "Submit")
], -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_clear-element" }, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_form-thank-you",
  style: {"display":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_r_button = _resolveComponent("r-button")!
  const _component_r_icon = _resolveComponent("r-icon")!
  const _component_Tail = _resolveComponent("Tail")!
  const _directive_trans = _resolveDirective("trans")!
  const _directive_trnew = _resolveDirective("trnew")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createTextVNode("Roxe One")
        ])), [
          [_directive_trans]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(" One-stop platform that makes it easy for restaurants ")
        ])), [
          [_directive_trans]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_r_button, {
              class: "mm30 button-roxe",
              id: "font-size test"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Try for free")
              ]),
              _: 1
            })
          ])
        ])), [
          [_directive_trans, 300]
        ])
      ])), [
        [_directive_trnew, 20]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)), [
        [_directive_trnew, 500]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_r_icon, {
              height: 120,
              width: 120,
              icon: "One-stop",
              class: "roxe-icon"
            }),
            _hoisted_19,
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_r_icon, {
              height: 120,
              width: 120,
              icon: "Cloud-based",
              class: "roxe-icon"
            }),
            _hoisted_22,
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_r_icon, {
              height: 120,
              width: 120,
              icon: "Save-Money",
              class: "roxe-icon"
            }),
            _hoisted_25,
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_r_icon, {
              height: 120,
              width: 120,
              icon: "Trusted-By",
              class: "roxe-icon"
            }),
            _hoisted_28,
            _hoisted_29
          ])
        ]),
        _hoisted_30,
        _createElementVNode("a", _hoisted_31, [
          _createVNode(_component_r_button, {
            class: "mtb30",
            id: "font-size"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Try for free")
            ]),
            _: 1
          })
        ])
      ])), [
        [_directive_trnew]
      ])
    ]),
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_r_icon, {
            height: 40,
            width: 40,
            icon: "Digital-Menus"
          }),
          _hoisted_36
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_r_icon, {
            height: 40,
            width: 40,
            icon: "Kitchen-Order"
          }),
          _hoisted_38
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_r_icon, {
            height: 40,
            width: 40,
            icon: "Delivery-Platform"
          }),
          _hoisted_40
        ])
      ])), [
        [_directive_trnew, 30]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_r_icon, {
            height: 40,
            width: 40,
            icon: "Group-1519"
          }),
          _hoisted_43
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_r_icon, {
            height: 40,
            width: 40,
            icon: "Contactless-Checkout"
          }),
          _hoisted_45
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_r_icon, {
            height: 40,
            width: 40,
            icon: "Reception-Management"
          }),
          _hoisted_47
        ])
      ])), [
        [_directive_trnew, 300]
      ])
    ]),
    _createElementVNode("a", _hoisted_48, [
      _createVNode(_component_r_button, {
        class: "mtb30 restaurant-button",
        id: "font-size"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Try for free")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_49, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_r_icon, {
              height: 80,
              width: 80,
              icon: "Inventory-Management"
            }),
            _hoisted_54,
            _hoisted_55
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_r_icon, {
              height: 80,
              width: 80,
              icon: "Business-Data"
            }),
            _hoisted_57,
            _hoisted_58
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_r_icon, {
              height: 80,
              width: 80,
              icon: "CRM-Management"
            }),
            _hoisted_60,
            _hoisted_61
          ])
        ]),
        _hoisted_62,
        _createElementVNode("a", _hoisted_63, [
          _createVNode(_component_r_button, { class: "mtb30" }, {
            default: _withCtx(() => [
              _createTextVNode("Try for free")
            ]),
            _: 1
          })
        ]),
        _hoisted_64
      ])), [
        [_directive_trnew]
      ])
    ]),
    _withDirectives(_createElementVNode("form", _hoisted_65, [
      _hoisted_66,
      _createElementVNode("div", _hoisted_74, [
        _hoisted_75,
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("input", {
              error: _ctx.data.first.err,
              errMsg: _ctx.data.first.msg,
              value: _ctx.data.first.value,
              type: "text",
              id: "yourname",
              name: "yourname",
              placeholder: "Type your full name",
              required: ""
            }, null, 8, _hoisted_79)
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _hoisted_81,
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("input", {
              type: "text",
              id: "email",
              name: "email",
              value: _ctx.data.email.value,
              placeholder: "Type your email",
              required: ""
            }, null, 8, _hoisted_83)
          ])
        ]),
        _createElementVNode("div", _hoisted_84, [
          _hoisted_85,
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("input", {
              type: "text",
              value: _ctx.data.last.value,
              id: "restaurantname",
              name: "restaurantname",
              placeholder: "Type your restaurant name",
              required: ""
            }, null, 8, _hoisted_87)
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          _hoisted_89,
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("input", {
              type: "text",
              value: _ctx.data.website.value,
              id: "website",
              name: "website",
              placeholder: "type your website name",
              required: ""
            }, null, 8, _hoisted_91)
          ])
        ]),
        _createElementVNode("div", _hoisted_92, [
          _hoisted_93,
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("textarea", {
              value: _ctx.data.message,
              id: "message",
              name: "message",
              placeholder: ""
            }, null, 8, _hoisted_95)
          ])
        ]),
        _hoisted_96,
        _hoisted_97
      ]),
      _hoisted_98
    ], 512), [
      [_vShow, false]
    ]),
    _createVNode(_component_Tail)
  ]))
}